import { Box } from "grommet"

export const SettingType = ({ option, ...props }) => {

    return (
        <Box direction="row" gap="small" align="center" pad="5px 10px" {...props}>{option.icon}{option.label}</Box>
    )
}